import { render, staticRenderFns } from "./allocation-card.vue?vue&type=template&id=1b9026a4&scoped=true&"
import script from "./allocation-card.vue?vue&type=script&lang=ts&"
export * from "./allocation-card.vue?vue&type=script&lang=ts&"
import style0 from "./allocation-card.vue?vue&type=style&index=0&id=1b9026a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9026a4",
  null
  
)

export default component.exports